import React from 'react';

export const IS_DRAGGING_CLASS_NAME = 'ak-dnd-is-dragging';

export default function DragDropNoSelect() {
	// Note that react-beautiful-dnd actually handles body styles when dragging
	// BUT it doesn't prevent the ICC placeholder from triggering on the board and backlog
	// and as a result we need this class here to prevent that behaviour

	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
		<style
			// eslint-disable-next-line react/no-danger
			dangerouslySetInnerHTML={{
				__html: `
                            /* disable hover events during drag */
                            body.${IS_DRAGGING_CLASS_NAME} * {
                                pointer-events: none;
                            }
                        `,
			}}
		/>
	);
}
